import * as React from 'react';
import { SetState } from 'types';

import { ColumnConfig } from '../ColumnsContext/types';
import { ColumnControlsState } from './types';

const fallbackCallback = () => console.error('No ColumnControlsContext exists');

type BaseRow = Record<'id', string>;
export interface ColumnsContextState<TRow extends BaseRow = BaseRow> {
  columns: ColumnConfig<TRow>[];
  getColumn: (name: string) => ColumnConfig<TRow> | undefined;
  setColumns: SetState<ColumnConfig<TRow>[]>;
  addColumn: (column: ColumnConfig<TRow>, isMount?: boolean) => void;
}

export const ColumnControlsContext = React.createContext<ColumnControlsState>({
  controlledColumns: [],
  updateColumn: fallbackCallback,
  controls: [],
  registerControl: fallbackCallback,
  unregisterControl: fallbackCallback,
});

export default ColumnControlsContext;
